var _circle, _rect, _path, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 14.5,
    fill: "white",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_176_1091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 10.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_176_1091)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.5V19.5H20L25 14.5V30.5L20 25.5H16ZM23 19.35L20.85 21.5H18V23.5H20.85L23 25.65V19.35Z",
    fill: "#9E00FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_176_1091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_176_1091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 25.5V19.5H20L25 14.5V30.5L20 25.5H16Z",
    fill: "#9E00FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerButton);
export default __webpack_public_path__ + "static/media/SpeakerButton.7aaee10ca30476c03e79ac9332025f64.svg";
export { ForwardRef as ReactComponent };